import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from '../ui/button';

export function CookieBanner({ onAcceptAll, onReject, onOpenSettings }) {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg">
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <Cookie className="h-5 w-5 text-muted-foreground mt-0.5 shrink-0" />
          <div className="min-w-0">
            <p className="text-sm font-medium">{t('gdpr.banner.title')}</p>
            <p className="text-sm text-muted-foreground mt-0.5">
              {t('gdpr.banner.description')}{' '}
              <Link to="/privacy-policy" className="underline hover:text-foreground transition-colors">
                {t('gdpr.banner.privacyLink')}
              </Link>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0 flex-wrap">
          <Button variant="ghost" size="sm" onClick={onOpenSettings}>
            {t('gdpr.banner.settings')}
          </Button>
          <Button variant="outline" size="sm" onClick={onReject}>
            {t('gdpr.banner.reject')}
          </Button>
          <Button size="sm" onClick={onAcceptAll}>
            {t('gdpr.banner.acceptAll')}
          </Button>
        </div>
      </div>
    </div>
  );
}
